import Vue from 'vue'
import Router from 'vue-router'
import Learn from './views/Learn.vue'
import Images from './views/Images.vue'
import Terms from './views/Terms.vue'
import Landing from './views/Landing.vue'
import ContentReview from './views/ContentReview.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Learn',
      component: Learn,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/images',
      name: 'Images',
      component: Images,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/tos',
      name: 'Landing',
      component: Landing,
      props: true
    },
    {
      path: '/cr',
      name: 'ContentReview',
      component: ContentReview,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name != 'Landing' && !store.state.termsOfService) {
    next({name: 'Landing'})
  }
  else {
    next()
  }
})

export default router
